/** The blurhash paint, kept to four lines with a DOM in them.
 *
 *  `decode()` is pure and returns pixels; only putImageData touches the page.
 *  Splitting it this way is deliberate: the part worth testing -- avgColor, in
 *  rows.ts -- is ours and pure, and this shim is small enough to read instead.
 *
 *  32x32 costs 0.159 ms (measured, node/V8; assume ~2x on an iPhone) and the
 *  canvas is stretched over the whole box, so the upscale IS the blur. Returns
 *  false rather than throwing on a hash the decoder rejects: a bad hash should
 *  cost one gradient, and the average colour underneath still covers the box.
 */
import { decode } from "blurhash";

export function paintBlurhash(canvas: HTMLCanvasElement, hash: string, size = 32): boolean {
  const ctx = canvas.getContext("2d");
  if (!ctx) return false; // jsdom, or a browser refusing a context
  try {
    const pixels = decode(hash, size, size);
    const image = ctx.createImageData(size, size);
    image.data.set(pixels);
    ctx.putImageData(image, 0, 0);
    return true;
  } catch {
    return false;
  }
}
